import { defineField, defineType } from "sanity";

export type SanctuaryPostFields = {
  title: string;
  category?: string[];
  clinicallyVerified?: boolean;
  contentValue?: number;
  postId?: string;
  postDetailsId?: string;
  topic?: string[];
  learningOutcome?: string;
  language?: string;
  keywords?: string[];
  description?: string;
  createdAt?: string;
};

export const sanctuaryPost = defineType({
  type: "object",
  name: "sanctuaryPost",
  title: "Sanctuary Post",
  fields: [
    // title stirng
    defineField({
      name: "title",
      type: "string",
      validation: (Rule) => Rule.required(),
      readOnly: true
    }),
    // category string[]
    defineField({
      name: "category",
      type: "array",
      of: [{ type: "string" }],
      readOnly: true
    }),
    // clinicallyVerified boolean
    defineField({
      name: "clinicallyVerified",
      type: "boolean",
      readOnly: true
    }),
    // contentValue number
    defineField({
      name: "contentValue",
      type: "number",
      readOnly: true
    }),
    // postId string
    defineField({
      name: "postId",
      type: "string",
      readOnly: true
    }),
    // postDetailsId
    defineField({
      name: "postDetailsId",
      type: "string",
      readOnly: true
    }),
    // topic string[]
    defineField({
      name: "topic",
      type: "array",
      of: [{ type: "string" }],
      readOnly: true
    }),
    // learningOutcome: string
    defineField({
      name: "learningOutcome",
      type: "string",
      readOnly: true
    }),
    // language
    defineField({
      name: "language",
      type: "string",
      readOnly: true
    }),
    // keywords string[]
    defineField({
      name: "keywords",
      type: "array",
      of: [{ type: "string" }],
      readOnly: true
    }),
    // description
    defineField({
      name: "description",
      type: "string",
      readOnly: true
    }),

    // createdAt
    defineField({
      name: "createdAt",
      type: "datetime",
      readOnly: true
    })
  ]
});
